export const goalPeriodTexts = {
  day: 'Every day',
  week: 'By week',
  month: 'By month',
  year: 'By year',
};
